import * as React from 'react'

import { FormikFormChunkProps } from '../../../types'
import { InjectedStepperProps } from '../../organisms'
import StepFormWrapper          from './StepFormWrapper'

type asFormStepType =
  <T>(FormChunk: React.ComponentType<FormikFormChunkProps<T>>) =>
    React.SFC<FormikFormChunkProps<T> & InjectedStepperProps>

const asFormStep: asFormStepType = FormChunk => {
  return props => (
    <StepFormWrapper {...props}>
      {(innerProps: any) => <FormChunk {...innerProps} />}
    </StepFormWrapper>
  )
}

export default asFormStep



// WEBPACK FOOTER //
// ./src/components/forms/wrappers/asFormStep.tsx